import { isNil } from "lodash";

export function escapeReactRoute(path: string): string {
    if (isNil(path)) {
        return path;
    }

    return path.replace(/([:()$*\\])/g, "\\$1");
}
